<template>
  <w-modal
    v-model="show"
    title="Pobieranie dokumentacji"
    :show-close-button="false"
    :close-on-submit="false"
    :hide-on-overlay="false"
    :hide-on-esc="false"
    @submit="$emit('close')"
    @close="$emit('close')"
  >
    <div class="row mb-2">
      <div class="form-group col-12">
        Do pobrania dokumentacji zostaną użyte wszystkie zaznaczone dokumenty, które posiadają załącznik danego rodzaju.
      </div>

      <div class="form-group col-12">
        <select v-if="views && views.length" id="view" v-model="selectedView" class="form-control">
          <option v-for="view in views" :key="'view_' + view.id" :value="view.id">
            {{ view.name }}
          </option>
        </select>

        <p v-else>Wybrane wnioski nie mają dokumentacji możliwej do pobrania.</p>
      </div>
    </div>

    <div slot="footer" class="w-100">
      <w-button class="btn btn-secondary float-left mr-2" text="Zamknij" @click="$emit('close')" />

      <div class="float-right">
        <post-form
          text="Pobierz pdf"
          icon="fal fa-cloud-download mr-2"
          button-class="btn-primary"
          :disabled="!view"
          :fields="filters"
          :url="pdfUrl"
        />
      </div>
    </div>
  </w-modal>
</template>

<script>
import WModal from '@witkac/bootstrap4-components/src/components/modal';
import { mapState } from 'vuex';

import PostForm from '@/components/postForm/PostForm';
import { config } from '@/utils/config';

export default {
  components: { PostForm, WModal },
  props: {
    // Czy modal ma być widoczny
    show: { type: Boolean, required: true },
    // Filtry dokumentów
    filters: { type: Array, required: true }
  },
  data() {
    return { selectedView: undefined };
  },
  computed: {
    ...mapState({ views: state => state.document.attachment.avaialbleViews }),
    // Aktalnie wybrany widok
    view() {
      return this.selectedView && this.views.find(view => view.id === this.selectedView);
    },
    // URL do generowania PDF
    pdfUrl() {
      return this.view && config.renderURL + `/pdf/joined/${this.view.id}`;
    }
  }
};
</script>
